module.exports = __webpack_public_path__ + "img/praedikat_wertvoll_russlandvonoben.049c09ba.png";